export default __webpack_public_path__ + "static/media/outward.9be2ed9d.svg";